import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-dropdown-field',
	templateUrl: './dropdown-field.component.html',
	styleUrls: ['./dropdown-field.component.scss'],
})
export class DropdownFieldComponent implements OnInit {
	@Input() inputName: string;
	@Input() interface = 'alert';
	@Input() form: UntypedFormGroup;
	@Input() label: string;
	@Input() list: Array<any>;
	@Input() listLabelKey: string;
	@Input() listValueKey: string;
	@Input() isError: boolean;
	@Input() placeholder: string;
	@Input() preValue: string;
	@Input() disabled = false;
	@Output() valueChange = new EventEmitter<any>();

	constructor() {
	}

	ngOnInit() {
		if (this.preValue) {
			const control = this.form.get(this.inputName);
			if (control) {
				control.setValue(this.preValue);
				if (this.disabled) {
					control.disable();
				}
			}
		}
	}	
}
